<template>
  <div> 
    <Videos :videoContents="videoContents" :imageContents="imageContents" :activeTab="activeTab" />
  </div>
</template>
<style>

</style>
<script>
import { core } from '../../config/pluginInit'
import Videos from './MovieCategoryPage/videos'
import ApiService from '../../services/api'

export default {
  name: 'MovieCategory',
  data() {
    return {
      activeTab: 'images',
      contents: [],
      videoContents: [],
      imageContents: []
    }
  },
  components: {
    Videos
  },
  methods: {
    getContentBytCategory() {
      ApiService.getContentByCategory(this.$route.params.category).then((response) => {
        this.$store.commit('setPoints', response.data.user_points)
        this.contents = response.data.data
        this.videoContents = this.contents.filter(content => {
          return content.content_type === 'Video'
        })
        this.imageContents = this.contents.filter(content => {
          return content.content_type === 'Image'
        })
        
        if (this.imageContents.length > 0) {
          this.activeTab = 'images'
        } else {
          this.activeTab = 'videos'
        }
      })
    }
  },
  created() {
    core.index()
    this.getContentBytCategory()
  }
}
</script>
